import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { CbicContentMstService } from 'app/entities/cbic-content-mst/service/cbic-content-mst.service';
import { CbicContentTypeMstService } from 'app/entities/cbic-content-type-mst/service/cbic-content-type-mst.service';
import { SessionStorageService } from 'ngx-webstorage';
import { CbicDocMstService } from 'app/entities/cbic-doc-mst/service/cbic-doc-mst.service';
import { DataUtils } from 'app/core/util/data-util.service';
import { UtilsService } from 'app/core/util/view-file.component';
import { CbicMenuMstService } from 'app/entities/cbic-menu-mst/service/cbic-menu-mst.service';
import { MatTabChangeEvent } from '@angular/material/tabs/tab-group';


@Component({
  selector: 'cbic-news-media-tableview',
  templateUrl: './news-media-tableview.component.html',
  styleUrls: ['./news-media-tableview.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewsMediaTableviewComponent implements OnInit {
  @Input() contentId: any;
  usedLanguage: any;
  color: any;
  // contentId: any;
  pressdataflag: any = 'New';
  newsMediaPressData: any;
  newsMediaPressDataNotFound = false;
  newsMediaDataNotfound: any;
  PdfDataList: any;
  firstPage: any;
  lastPage: any;
  nextPage: any;
  nextSize: any;
  prevPage: any;
  prevSize: any;
  page = 1;
  Pageing = 0;
  pageSize: any = 10;
  count: any = 0;
  tableSize = 10;
  tableSizes = [10, 15, 20, 25, 50, 100, 200]

  constructor(private sessionStorageService: SessionStorageService, private changeLnService: ChangeLanguageService, private contentMstService: CbicContentMstService
    , private cbicContentTypeMstService: CbicContentTypeMstService, private http: HttpClient,
    public menuService: CbicMenuMstService
    , private cbicDocMstService: CbicDocMstService, private dataUtils: DataUtils, private utils: UtilsService) { }



  isDataAvailable() {
    let dataAvailable = true;
    dataAvailable &&= this.newsMediaPressData != null && this.newsMediaPressData.length !== 0;
    if (dataAvailable === false) {
      this.newsMediaDataNotfound = 'No data available.';
    }
    return dataAvailable;
  };

  ngOnInit(): void {
    this.usedLanguage = this.changeLnService.getLanguage();
    this.getnewsmediaData(this.contentId, 0, 10, this.pressdataflag);
    this.color = this.sessionStorageService.retrieve('colr');
    this.getContentCount(this.contentId, this.pressdataflag);
  }

  getnewsmediaData(contentTypeId: any, Pageing: any, pageSize: any, flag: any): void {
    this.contentMstService.getNewsAndMediadocMstData(contentTypeId, Pageing, pageSize, flag)
      .subscribe(
        (res: HttpResponse<any>) => {
          this.newsMediaPressData = res
          if (this.newsMediaPressData.length === 0) {
            this.newsMediaPressDataNotFound = true
          } else {
            this.newsMediaPressDataNotFound = false;
          }
        });
  }

  getContentCount(contentId: any, flag: any): void {
    this.contentMstService.getContentCountByParentId(contentId, flag).subscribe((res: HttpResponse<number>) => {
      if (res) {
        this.count = res.body;
        console.log(this.count);
      }
    });
  }

  ViewPdf(filePath: any) {
    this.utils.viewOpenning(filePath);
  }

  onTableDataChange(event: any) {
    // const request: any = {};
    this.Pageing = event - 1;
    this.pageSize = this.tableSize;
    this.getnewsmediaData(this.contentId, this.Pageing, this.pageSize, this.pressdataflag);
  }

  ontableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    const request: any = {};
    this.Pageing = this.page - 1;
    // request['size'] = event.pageSize.toString();
    this.getnewsmediaData(this.contentId, this.Pageing, this.tableSize, this.pressdataflag);
  }

  pressReleaseClick(event: MatTabChangeEvent) {
    if (event.index === 1) {
      this.pressdataflag = 'Old'
      this.Pageing = 0;
      this.pageSize = this.tableSize;
    }
    else {
      this.pressdataflag = 'New'
      this.Pageing = 0;
      this.pageSize = this.tableSize;
    }
    this.page = 1;
    this.getnewsmediaData(event.tab.textLabel, this.Pageing, this.pageSize, this.pressdataflag)
    this.getContentCount(this.contentId, this.pressdataflag);
  }

}
